import { render } from "./SubmitView.vue?vue&type=template&id=4a400736&scoped=true&ts=true"
import script from "./SubmitView.vue?vue&type=script&lang=ts"
export * from "./SubmitView.vue?vue&type=script&lang=ts"

import "./SubmitView.vue?vue&type=style&index=0&id=4a400736&lang=css"
import "./SubmitView.vue?vue&type=style&index=1&id=4a400736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a400736"]])

export default __exports__